import React, { Component } from 'react';
import '../assets/css/bootstrap.min.css';
import '../../node_modules/font-awesome/css/font-awesome.min.css';
import '../assets/css/style.css';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Tabs from "../Components/Tabs";
import Header from './Header';

const validEmailRegex = RegExp(/^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i);
const validateForm = (errors) => {
    let valid = true;
    Object.values(errors).forEach(
        (val) => val.length > 0 && (valid = false)
    );
    return valid;
}

class LoginSignup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: "",
            confirmEmail: "",
            username: "",
            password: "",
            hidden: true,
            activeTab: "",
            errors: {
                email: '',
                confirmEmail: '',
                username: '',
                password: '',
            }
        }
        this.toggleShow = this.toggleShow.bind(this);
    }

    toggleShow() {
        this.setState({ hidden: !this.state.hidden });
    }

    handleChange = (event) => {
        event.preventDefault();
        const { name, value } = event.target;
        let errors = this.state.errors;

        switch (name) {
            case 'email':
                errors.email =
                    validEmailRegex.test(value)
                        ? ''
                        : 'Email is not valid!';
                break;
            case 'confirmEmail':
                errors.confirmEmail =
                this.state.email === this.state.confirmEmail
                        ? ''
                        : 'Not Matched!';
                break;
            case 'username':
                errors.username =
                    value.length < 5
                        ? 'User Name must be 5 characters long!'
                        : '';
                break;
            case 'password':
                errors.password =
                    value.length < 8
                        ? 'Password must be 8 characters long!'
                        : '';
                break;
            default:
                break;
        }

        this.setState({ errors, [name]: value });
    }

    signup = (event) => {
        if (validateForm(this.state.errors)) {
            console.log("email", this.state.email, this.state.username, this.state.password)


            axios.post('http://192.168.29.49:3000/v1/auth/register', {
                "email": this.state.email,
                "name": this.state.username,
                "password": this.state.password,
                "role": "user"
            })
                .then(response => {
                    console.log(response);
                    console.log(response.data)
                })
                .catch(error => {
                    alert(error.response.data.message)
                    // console.log(error.response.data.message);
                });
        } else {
            // console.error('Invalid Form')
            alert("Invalid Form");
        }
    }

    // signup = (event) => {

    //     this.setState({
    //         emailError: "",
    //         confirmEmailError: "",
    //         usernameError: "",
    //         passwordError: ""
    //     })
    //     if (!(this.state.email) && !(this.state.confirmEmail) && !(this.state.username) && !(this.state.password)) {
    //         this.setState({
    //             emailError: "!Required",
    //             confirmEmailError: "!Required",
    //             usernameError: "!Required",
    //             passwordError: "!Required"
    //         })
    //     }
    //     else if (!(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(this.state.email)) && !(this.state.confirmEmail) && !(this.state.username) && !(this.state.password)) {
    //         this.setState({
    //             emailError: "Invalid Email",
    //             confirmEmailError: "!Required",
    //             usernameError: "!Required",
    //             passwordError: "!Required"
    //         })
    //     }
    //     else if ((/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(this.state.email)) && !(this.state.confirmEmail) && !(this.state.username) && !(this.state.password)) {
    //         this.setState({
    //             confirmEmailError: "!Required",
    //             usernameError: "!Required",
    //             passwordError: "!Required"
    //         })
    //     }
    //     else if ((this.state.email) !== (this.state.confirmEmail) && !(this.state.username) && !(this.state.password)) {
    //         this.setState({
    //             confirmEmailError: "Not Matched",
    //             usernameError: "!Required",
    //             passwordError: "!Required"
    //         })
    //     }
    //     else if ((this.state.email) === (this.state.confirmEmail) && !(this.state.username) && !(this.state.password)) {
    //         this.setState({
    //             usernameError: "!Required",
    //             passwordError: "!Required"
    //         })
    //     }
    //     else if ((this.state.email) === (this.state.confirmEmail) && (this.state.username) && !(this.state.password)) {
    //         this.setState({
    //             passwordError: "!Required"
    //         })
    //     }
    //     // else if ((this.state.email) === (this.state.confirmEmail) && (this.state.username) && !(/^[A-Za-z]\w{7,14}$/i.test(this.state.password))) {
    //     //     this.setState({
    //     //         passwordError: "Invalid Password"
    //     //     })
    //     // }
    //     else {
    //         console.log("email", this.state.email, this.state.username, this.state.password)


    //         axios.post('http://192.168.29.49:3000/v1/auth/register', {
    //             "email": this.state.email,
    //             "name": this.state.username,
    //             "password": this.state.password,
    //             "role": "user"
    //         })
    //             .then(response => {
    //                 console.log(response);
    //                 console.log(response.data)
    //             })
    //             .catch(error => {
    //                 alert(error.response.data.message)
    //                 // console.log(error.response.data.message);
    //             });
    //     }
    // }

    signin() {
        this.setState({
            emailError: "",
            passwordError: ""
        })
        if (!(this.state.email) && !(this.state.password)) {
            this.setState({
                emailError: "!Rqeuired",
                passwordError: "!Required"
            })
        }
        else if (!(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(this.state.email)) && !(this.state.password)) {
            this.setState({
                emailError: "Invalid Email",
                passwordError: "!Required"
            })
        }
        else if ((/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(this.state.email)) && !(this.state.password)) {
            this.setState({
                passwordError: "!Required"
            })
        }
        else {
            alert("Signed in sucessfully");
            window.location = "/loginSignup";
        }
    }

    render() {
        const { errors } = this.state;
        return (
            <div className="main-wrapper">
                {/* Header area start */}
                <Header />
                {/* Header area end */}

                {/* Login SignUp content area start */}
                <div className="container mb-5">
                    <div className="row justify-content-center">
                        <div className="col-lg-6 text-center login-area">
                            <h1>Lorem</h1>
                            <Tabs>
                                <div className="signup-tab" label="Sign Up">
                                    <div className="sign-up input-icons p-4">
                                        <p className="signup-content">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed
                                            diam nonummy nibh euismod tincidunt ut laoreet dolore</p>
                                        <input className="profile-bio mb-4 form-control" name="email" onChange={this.handleChange} type="email" placeholder="myemail@myemail.com" noValidate />
                                        {errors.email.length > 0 &&
                                            <p className='error'>{errors.email}</p>}

                                        <input className="profile-bio mb-4 form-control" name="confirmEmail" onChange={this.handleChange} type="email" placeholder="Confirm Email Address" />
                                        {errors.confirmEmail.length > 0 &&
                                            <p className='error'>{errors.confirmEmail}</p>}

                                        <input className="profile-bio mb-4 form-control" name="username" onChange={this.handleChange} type="text" placeholder="User Name" />
                                        {errors.username.length > 0 &&
                                            <p className='error'>{errors.username}</p>}

                                        <input className="profile-bio mb-2 form-control" name="password" onChange={this.handleChange} type={this.state.hidden ? 'password' : 'text'} value={this.state.password} placeholder="Password" />
                                        <i className="fa fa-eye" onClick={this.toggleShow}></i>
                                        {errors.password.length > 0 &&
                                            <p className='error'>{errors.password}</p>}
                                        {/* <p className="error">{this.state.passwordError}</p> */}
                                        <p className="password-details text-left mb-3">Password must be at least 8 characters and contain 1 special
                                            character or number.</p>
                                        <p className="subscribe text-left">
                                            <input type="checkbox" className="profile-bio" />&emsp;
                                            <label>Subscribe to mailing list</label>
                                        </p>
                                        <button onClick={() => this.signup()} >SIGN UP</button>
                                        <p className="password-details text-left">By signing up, you agree to the <Link to="#">Terms and Conditions </Link> and <Link to="#">Privacy Policy.</Link></p>
                                    </div>
                                </div>
                                <div className="signin-tab" label="Sign In">
                                    <div className="sign-in pt-4">
                                        <p className="signup-content">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed
                                            diam nonummy nibh euismod tincidunt ut laoreet dolore</p>
                                        <p className="error">{this.state.emailError}</p>
                                        <input className="profile-bio mb-4 form-control" onChange={(event) => { this.setState({ email: event.target.value }) }} type="email" placeholder="myemail@myemail.com" />
                                        <p className="error">{this.state.passwordError}</p>
                                        <input className="profile-bio mb-2 form-control" onChange={(event) => { this.setState({ password: event.target.value }) }} type="password" placeholder="Password" />
                                        <p className="subscribe text-left">
                                            <input type="checkbox" className="profile-bio" />&emsp;
                                            <label>Save Password</label>
                                        </p>
                                        <button onClick={() => this.signin()} >SIGN IN</button>
                                    </div>
                                </div>
                            </Tabs>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-lg-6 forget-password">
                            <Link to="#">Forget Password</Link>
                        </div>
                    </div>
                </div>
                {/* Login SignUp content area end */}
            </div>
        )
    }
};

export default LoginSignup;